"use client";

import dynamic from "next/dynamic";

import type { BvWidgetProps } from "./bvWidget.component";

export const BvWidgetContainer = dynamic<BvWidgetProps>(
  () => import("./bvWidget.component"),
  {
    ssr: false,
  },
);
